var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsdbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 54,
    viewBox: "0 0 102 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.12319 1.20768V26.861H0.637608V1.20768H4.12319Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0912 20.7952V21.7135C10.0912 23.2131 10.5928 24.2493 11.953 24.2493C13.1942 24.2493 13.7383 23.4827 13.7383 21.9494C13.7383 20.4161 13.2707 19.5315 10.9073 17.9982C8.19537 16.2711 6.92016 14.8473 6.92016 12.0419C6.92016 8.89104 8.58643 6.81855 11.9615 6.81855C15.6001 6.81855 16.9603 8.93316 16.9603 12.2694V13.1118H13.5853V11.9576C13.5853 10.458 13.1177 9.73351 11.9615 9.73351C10.8393 9.73351 10.3717 10.5423 10.3717 11.7723C10.3717 13.036 10.7968 13.6173 12.6926 14.8473C15.9487 16.9198 17.2239 18.3015 17.2239 21.5703C17.2239 25.2603 15.4386 27.1811 11.834 27.1811C7.57476 27.1811 6.5631 24.4936 6.5631 21.6882V20.8036H10.0912V20.7952Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4682 1.20768H24.6626C30.2055 1.20768 31.2512 4.28271 31.2512 8.73097V18.7143C31.2512 22.6318 30.5881 26.8526 24.5861 26.8526H19.4682V1.20768ZM22.9538 23.9039H24.3481C27.179 23.9039 27.7231 22.2105 27.7231 19.2535V8.42768C27.7231 5.81601 27.2555 4.16476 24.3481 4.16476H22.9538V23.9039Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3457 1.20768H39.302C43.6038 1.20768 45.2275 3.28016 45.2275 6.92807V7.96432C45.2275 11.5701 44.0288 12.6485 42.8216 13.1455C44.0968 13.5668 45.7291 14.6451 45.7291 18.293V20.2139C45.7291 24.5947 44.0203 26.861 39.5656 26.861H34.3457V1.20768ZM38.996 11.8144C41.2829 11.8144 41.9375 11.0478 41.9375 8.31815V7.23979C41.9375 5.04936 41.1639 4.08894 39.1065 4.08894H37.7123V11.806H38.996V11.8144ZM37.7208 24.0219H39.1915C41.6739 24.0219 42.3285 22.8677 42.3285 20.1465V18.3773C42.3285 15.7656 41.5124 14.6536 38.996 14.6536H37.7208V24.0219Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54726 43.1292V51.3685H0.425072V43.1292H1.54726Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83414 49.4224V49.7173C3.83414 50.1975 3.99567 50.5345 4.42924 50.5345C4.82881 50.5345 4.99884 50.2902 4.99884 49.7931C4.99884 49.2961 4.84581 49.018 4.08918 48.521C3.22204 47.965 2.80547 47.51 2.80547 46.6086C2.80547 45.5976 3.34106 44.9321 4.42074 44.9321C5.59393 44.9321 6.02751 45.6145 6.02751 46.6844V46.954H4.95633V46.5833C4.95633 46.1031 4.8033 45.8672 4.42924 45.8672C4.07218 45.8672 3.91916 46.1284 3.91916 46.5243C3.91916 46.9287 4.05518 47.1141 4.66728 47.51C5.71295 48.1756 6.12102 48.6221 6.12102 49.6667C6.12102 50.8546 5.55143 51.4696 4.39524 51.4696C3.02651 51.4696 2.70345 50.6103 2.70345 49.7089V49.4224H3.83414Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26021 51.3685V42.7753H8.36539V51.3685H7.26021Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9562 50.1638C12.9562 50.5682 12.9562 51.1495 12.9817 51.3685H11.9615C11.936 51.2337 11.885 50.9726 11.885 50.8883C11.6724 51.3096 11.2984 51.4696 10.8308 51.4696C9.88715 51.4696 9.51308 50.6187 9.51308 49.6415V49.532C9.51308 48.0239 10.5078 47.569 11.6554 47.569H11.851V46.6844C11.851 46.1536 11.7745 45.8419 11.3409 45.8419C10.9158 45.8419 10.8053 46.1621 10.8053 46.6086V46.7349H9.70862V46.6254C9.70862 45.724 10.0572 44.9321 11.3749 44.9321C12.5566 44.9321 12.9562 45.6145 12.9562 46.6001V50.1638ZM11.8765 48.4199H11.6129C10.9753 48.4199 10.5673 48.6811 10.5673 49.5151V49.6162C10.5673 50.1217 10.7373 50.4924 11.1794 50.4924C11.6809 50.4924 11.8765 50.1385 11.8765 49.2371V48.4199Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4694 46.8697C14.4694 45.6482 14.4694 45.328 14.4609 45.0331H15.5151C15.5491 45.2185 15.5491 45.387 15.5661 45.5976C15.7616 45.1764 16.1357 44.9321 16.6713 44.9321C17.1814 44.9321 17.5299 45.1427 17.6829 45.6313C17.8955 45.2606 18.227 44.9321 18.8901 44.9321C19.5618 44.9321 20.1314 45.2522 20.1314 46.4822V51.3685H19.0092V46.6928C19.0092 46.221 18.8986 45.9262 18.4906 45.9262C17.9805 45.9262 17.853 46.3474 17.853 46.9961V51.3601H16.7308V46.7265C16.7308 46.0947 16.5523 45.9262 16.1952 45.9262C15.6851 45.9262 15.5746 46.3558 15.5746 47.013V51.3685H14.4694V46.8697Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6106 42.7753H22.7328V44.098H21.6106V42.7753ZM21.6106 45.0331H22.7158V51.3685H21.6106V45.0331Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4086 49.3129V49.3972C27.4086 50.5177 27.1195 51.4696 25.6998 51.4696C24.3226 51.4696 24.0335 50.5429 24.0335 49.2371V46.9456C24.0335 45.9009 24.4076 44.9321 25.7593 44.9321C27.213 44.9321 27.4001 45.9767 27.4001 46.7939V47.0382H26.2949V46.7939C26.2949 46.2632 26.2184 45.8672 25.7338 45.8672C25.3087 45.8672 25.1472 46.1873 25.1472 46.8192V49.5572C25.1472 50.0543 25.2492 50.5345 25.7338 50.5345C26.1844 50.5345 26.2949 50.1975 26.2949 49.5741V49.3129H27.4086Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6476 43.1292H32.3139C34.0907 43.1292 34.4307 44.1148 34.4307 45.547V48.7569C34.4307 50.0122 34.2182 51.3685 32.2884 51.3685H30.6476V43.1292ZM31.7613 50.4165H32.2119C33.1215 50.4165 33.2915 49.8774 33.2915 48.9254V45.446C33.2915 44.6035 33.1385 44.0811 32.2119 44.0811H31.7613V50.4165Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 48.4704V49.4477C36.7346 50.0037 36.8451 50.5345 37.3977 50.5345C37.9418 50.5345 38.0353 50.0627 38.0353 49.5488V49.5151H39.1065V49.5488C39.1065 50.2396 38.9535 51.4696 37.4147 51.4696C35.91 51.4696 35.6379 50.5176 35.6379 49.2371V47.0382C35.6379 46.1368 35.9525 44.9321 37.4147 44.9321C38.724 44.9321 39.132 45.8419 39.132 47.0382V48.4704H36.7346ZM38.0608 47.5943V46.8782C38.0608 46.2969 37.9503 45.8672 37.4147 45.8672C36.9132 45.8672 36.7431 46.2379 36.7431 46.8866V47.5858H38.0608V47.5943Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1469 45.0331C41.3424 46.2042 41.793 48.8158 41.9545 50.1385H41.963C42.0735 48.8917 42.6006 46.28 42.8131 45.0331H43.9183L42.5496 51.3685H41.2914L39.9567 45.0331H41.1469Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8311 48.4704V49.4477C45.8311 50.0037 45.9417 50.5345 46.4942 50.5345C47.0383 50.5345 47.1319 50.0627 47.1319 49.5488V49.5151H48.203V49.5488C48.203 50.2396 48.05 51.4696 46.5112 51.4696C45.0065 51.4696 44.7345 50.5176 44.7345 49.2371V47.0382C44.7345 46.1368 45.049 44.9321 46.5112 44.9321C47.8205 44.9321 48.2285 45.8419 48.2285 47.0382V48.4704H45.8311ZM47.1574 47.5943V46.8782C47.1574 46.2969 47.0468 45.8672 46.5112 45.8672C46.0097 45.8672 45.8396 46.2379 45.8396 46.8866V47.5858H47.1574V47.5943Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5037 51.3685V42.7753H50.6089V51.3685H49.5037Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4972 46.9203V49.4477C55.4972 50.8041 54.8256 51.4696 53.6949 51.4696C52.5388 51.4696 51.9182 50.8041 51.9182 49.4561V46.8782C51.9182 45.5555 52.6493 44.9321 53.7375 44.9321C54.8511 44.9321 55.4972 45.6313 55.4972 46.9203ZM53.0318 46.8529V49.4898C53.0318 50.0796 53.2189 50.4755 53.7205 50.4755C54.171 50.4755 54.3836 50.1554 54.3836 49.473V46.8445C54.3836 46.3053 54.222 45.8925 53.7119 45.8925C53.2444 45.9093 53.0318 46.2547 53.0318 46.8529Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8065 46.8529C56.8065 45.9936 56.8065 45.4207 56.798 45.0247H57.8521C57.8776 45.1511 57.9031 45.4207 57.9031 45.665C58.0732 45.2606 58.4217 44.9236 59.0593 44.9236C59.952 44.9236 60.3771 45.5302 60.3771 46.7771V49.414C60.3771 50.8462 59.867 51.4612 58.9488 51.4612C58.3622 51.4612 58.0647 51.1748 57.9116 50.8799V53.4916H56.8065V46.8529ZM57.9116 49.2202C57.9116 49.9111 58.0222 50.4671 58.6003 50.4671C59.1018 50.4671 59.2634 50.088 59.2634 49.4309V46.8529C59.2634 46.1958 59.0423 45.9262 58.6513 45.9262C58.1327 45.9262 57.9201 46.3053 57.9201 47.0719V49.2202H57.9116Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6948 46.8697C61.6948 45.6482 61.6948 45.328 61.6863 45.0331H62.7405C62.7745 45.2185 62.7745 45.387 62.7915 45.5976C62.987 45.1764 63.3611 44.9321 63.8966 44.9321C64.4067 44.9321 64.7553 45.1427 64.9083 45.6313C65.1209 45.2606 65.4524 44.9321 66.1155 44.9321C66.7871 44.9321 67.3567 45.2522 67.3567 46.4822V51.3685H66.2345V46.6928C66.2345 46.221 66.124 45.9262 65.716 45.9262C65.2059 45.9262 65.0783 46.3474 65.0783 46.9961V51.3601H63.9562V46.7265C63.9562 46.0947 63.7776 45.9262 63.4206 45.9262C62.9105 45.9262 62.8 46.3558 62.8 47.013V51.3685H61.6948V46.8697Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7541 48.4704V49.4477C69.7541 50.0037 69.8646 50.5345 70.4172 50.5345C70.9613 50.5345 71.0548 50.0627 71.0548 49.5488V49.5151H72.1345V49.5488C72.1345 50.2396 71.9815 51.4696 70.4427 51.4696C68.938 51.4696 68.6659 50.5176 68.6659 49.2371V47.0382C68.6659 46.1368 68.9805 44.9321 70.4427 44.9321C71.7519 44.9321 72.16 45.8419 72.16 47.0382V48.4704H69.7541ZM71.0803 47.5943V46.8782C71.0803 46.2969 70.9698 45.8672 70.4342 45.8672C69.9326 45.8672 69.7626 46.2379 69.7626 46.8866V47.5858H71.0803V47.5943Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4182 46.9793C73.4182 45.6987 73.4182 45.328 73.4097 45.0331H74.4639C74.4894 45.1848 74.5149 45.4123 74.5149 45.6397C74.7019 45.2353 75.0505 44.9405 75.6881 44.9405C76.4362 44.9405 76.9803 45.3701 76.9803 46.558V51.377H75.8581V46.7771C75.8581 46.1873 75.6626 45.9346 75.263 45.9346C74.7785 45.9346 74.5319 46.1789 74.5319 47.1815V51.377H73.4267V46.9793H73.4182Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8815 45.0331H78.5871V43.4914H79.6923V45.0331H80.5424V46.0104H79.6923V49.97C79.6923 50.2818 79.7433 50.5513 80.1428 50.5513C80.2534 50.5513 80.4319 50.5429 80.4999 50.5176V51.3601C80.3044 51.4612 79.9898 51.4696 79.7688 51.4696C79.0377 51.4696 78.5871 51.2253 78.5871 50.1722V46.0188H77.8815V45.0331Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6029 43.1292H85.1927C86.5699 43.1292 87.097 43.7947 87.097 44.9657V45.3027C87.097 46.4653 86.7144 46.8108 86.3234 46.9708C86.7314 47.1056 87.2585 47.451 87.2585 48.6221V49.2371C87.2585 50.644 86.7144 51.3685 85.2777 51.3685H83.5944V43.1292H83.6029ZM85.0992 46.5327C85.8303 46.5327 86.0428 46.2884 86.0428 45.4123V45.0668C86.0428 44.3676 85.7963 44.0559 85.1332 44.0559H84.6826V46.5327H85.0992ZM84.6826 50.4587H85.1587C85.9578 50.4587 86.1704 50.088 86.1704 49.2118V48.6474C86.1704 47.8049 85.9068 47.451 85.0992 47.451H84.6911V50.4587H84.6826Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7558 50.1638C91.7558 50.5682 91.7558 51.1495 91.7813 51.3685H90.7611C90.7356 51.2337 90.6846 50.9726 90.6846 50.8883C90.4721 51.3096 90.098 51.4696 89.6304 51.4696C88.6868 51.4696 88.3127 50.6187 88.3127 49.6415V49.532C88.3127 48.0239 89.3074 47.569 90.4551 47.569H90.6506V46.6844C90.6506 46.1536 90.5741 45.8419 90.1405 45.8419C89.7154 45.8419 89.6049 46.1621 89.6049 46.6086V46.7349H88.5082V46.6254C88.5082 45.724 88.8568 44.9321 90.1745 44.9321C91.3562 44.9321 91.7558 45.6145 91.7558 46.6001V50.1638ZM90.6676 48.4199H90.4041C89.7665 48.4199 89.3584 48.6811 89.3584 49.5151V49.6162C89.3584 50.1217 89.5284 50.4924 89.9705 50.4924C90.4721 50.4924 90.6676 50.1385 90.6676 49.2371V48.4199Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2605 46.9793C93.2605 45.6987 93.2605 45.328 93.252 45.0331H94.3062C94.3317 45.1848 94.3572 45.4123 94.3572 45.6397C94.5443 45.2353 94.8928 44.9405 95.5304 44.9405C96.2785 44.9405 96.8226 45.3701 96.8226 46.558V51.377H95.7004V46.7771C95.7004 46.1873 95.5049 45.9346 95.1053 45.9346C94.6208 45.9346 94.3742 46.1789 94.3742 47.1815V51.377H93.269V46.9793H93.2605Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4326 47.8554C99.7301 47.1562 100.342 45.8166 100.691 45.0331H101.864C101.439 45.8925 101.056 46.6338 100.665 47.3668L102 51.377H100.784L99.9172 48.4452C99.7896 48.681 99.5431 49.1697 99.4326 49.3803V51.377H98.3274V42.7837H99.4326V47.8554Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12535 32.6909C2.26988 32.6909 2.3974 32.6404 2.49942 32.5477C2.60143 32.455 2.65244 32.3286 2.65244 32.1939C2.65244 32.0506 2.60143 31.9327 2.49942 31.84C2.3974 31.7473 2.26988 31.6968 2.12535 31.6968C1.98083 31.6968 1.85331 31.7473 1.75129 31.84C1.64928 31.9327 1.59827 32.0506 1.59827 32.1939C1.59827 32.3371 1.64928 32.455 1.75129 32.5477C1.85331 32.6404 1.97233 32.6909 2.12535 32.6909Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97866 32.6909C4.13169 32.6909 4.25071 32.6404 4.36123 32.5477C4.46324 32.455 4.51425 32.3371 4.51425 32.1939C4.51425 32.0506 4.46324 31.9327 4.36123 31.8316C4.25921 31.7389 4.13169 31.6884 3.97866 31.6884C3.82564 31.6884 3.70662 31.7389 3.6046 31.8316C3.50258 31.9243 3.45158 32.0422 3.45158 32.1854C3.45158 32.3286 3.50258 32.4466 3.6046 32.5393C3.69812 32.6404 3.82564 32.6909 3.97866 32.6909Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80963 40.2732C6.66511 40.2732 6.53759 40.3237 6.43557 40.4248C6.33356 40.5259 6.28255 40.6439 6.28255 40.7871C6.28255 40.9303 6.33356 41.0483 6.43557 41.1409C6.53759 41.2336 6.66511 41.2757 6.80963 41.2757C6.95416 41.2757 7.08168 41.2336 7.1837 41.1409C7.28571 41.0483 7.33672 40.9303 7.33672 40.7871C7.33672 40.6439 7.28571 40.5259 7.1837 40.4248C7.08168 40.3237 6.95416 40.2732 6.80963 40.2732Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66294 40.2732C8.50992 40.2732 8.3909 40.3237 8.28888 40.4248C8.18687 40.5259 8.13586 40.6439 8.13586 40.7871C8.13586 40.9303 8.18687 41.0483 8.28888 41.1409C8.3909 41.2336 8.51842 41.2757 8.66294 41.2757C8.81597 41.2757 8.93499 41.2336 9.04551 41.1409C9.14752 41.0483 9.19853 40.9303 9.19853 40.7871C9.19853 40.6439 9.14752 40.5175 9.04551 40.4248C8.94349 40.3153 8.81597 40.2732 8.66294 40.2732Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8731 33.0616C19.0262 33.0616 19.1537 33.0111 19.2642 32.9184C19.3662 32.8257 19.4172 32.6993 19.4172 32.5477C19.4172 32.396 19.3662 32.2781 19.2642 32.177C19.1622 32.0759 19.0262 32.0254 18.8731 32.0254C18.7201 32.0254 18.5926 32.0759 18.4821 32.177C18.3801 32.2781 18.3291 32.396 18.3291 32.5477C18.3291 32.6993 18.3801 32.8173 18.4821 32.9184C18.5841 33.0111 18.7116 33.0616 18.8731 33.0616Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5744 33.0616C23.7275 33.0616 23.855 33.0111 23.957 32.9184C24.059 32.8257 24.11 32.7078 24.11 32.5645C24.11 32.4213 24.059 32.3034 23.957 32.2023C23.855 32.1096 23.7275 32.0591 23.5744 32.0591C23.4214 32.0591 23.3024 32.1096 23.2004 32.2023C23.0983 32.295 23.0473 32.4129 23.0473 32.5561C23.0473 32.6993 23.0983 32.8173 23.2004 32.91C23.3024 33.0111 23.4299 33.0616 23.5744 33.0616Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7211 33.0616C21.8656 33.0616 21.9932 33.0111 22.0952 32.9184C22.1972 32.8257 22.2482 32.6993 22.2482 32.5645C22.2482 32.4213 22.1972 32.3034 22.0952 32.2107C21.9932 32.118 21.8656 32.0675 21.7211 32.0675C21.5766 32.0675 21.4491 32.118 21.3471 32.2107C21.245 32.3034 21.194 32.4213 21.194 32.5645C21.194 32.7078 21.245 32.8257 21.3471 32.9184C21.4491 33.0111 21.5766 33.0616 21.7211 33.0616Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7635 38.5208H28.5052H28.3097H27.06V31.5704H26.2949V38.5208H25.0367H24.8496H23.0898V34.1231H22.3247V38.5208H20.4884H20.2929H19.2897V34.1231H18.5246V38.5208H17.5809H17.3854H16.1952C16.3567 38.1754 16.4332 37.7963 16.4332 37.4003C16.4332 36.6168 16.1612 35.9597 15.6341 35.429C15.0985 34.8982 14.4439 34.6286 13.6618 34.6286C12.8796 34.6286 12.225 34.8982 11.6979 35.4374C11.1709 35.9766 10.9073 36.6337 10.9073 37.4088C10.9073 37.7879 10.9838 38.167 11.1369 38.5293H10.1337H9.94666H8.18686V34.1315H7.42174V38.5293H5.56843H5.3899H4.36973V33.6598H3.6046V34.1315H3.16253C2.21887 34.1315 1.45374 34.3759 0.867144 34.8645C0.289048 35.3363 0 35.9597 0 36.7095C0 37.5604 0.29755 38.2007 0.90115 38.6304C1.50475 39.0684 2.25288 39.2791 3.16253 39.2791H5.3899H5.56843H9.94666H10.1337H11.6299C12.1655 39.8519 12.8456 40.13 13.6618 40.13C14.4779 40.13 15.158 39.8435 15.7021 39.2791H17.3854H17.5809H20.2929H20.4884H24.8496H25.0367H28.3097H28.5052H30.5286V31.5704H29.7635V38.5208ZM3.6046 38.5208H2.84797C2.25288 38.5208 1.75979 38.3608 1.36023 38.0322C0.96066 37.7036 0.765127 37.274 0.765127 36.7264C0.765127 36.1788 0.977663 35.7407 1.39423 35.3953C1.8108 35.0498 2.29538 34.8813 2.84797 34.8813H3.6046V38.5208ZM15.09 38.8073C14.6989 39.1864 14.2229 39.3717 13.6533 39.3717C13.0922 39.3717 12.6161 39.178 12.242 38.7904C11.868 38.4029 11.6809 37.9311 11.6809 37.3835C11.6809 36.8359 11.868 36.3641 12.242 35.9766C12.6161 35.589 13.0922 35.3953 13.6618 35.3953C14.2399 35.3953 14.716 35.589 15.0985 35.9681C15.4811 36.3472 15.6766 36.8275 15.6766 37.4003C15.6766 37.9564 15.4811 38.4366 15.09 38.8073Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1512 36.8696C37.3042 36.8696 37.4317 36.819 37.5423 36.7264C37.6443 36.6337 37.6953 36.5073 37.6953 36.3557C37.6953 36.204 37.6443 36.0861 37.5423 35.985C37.4402 35.8839 37.3042 35.8418 37.1512 35.8418C36.9982 35.8418 36.8706 35.8923 36.7601 35.985C36.6581 36.0861 36.6071 36.204 36.6071 36.3557C36.6071 36.5073 36.6581 36.6253 36.7601 36.7264C36.8621 36.819 36.9897 36.8696 37.1512 36.8696Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1512 38.6725C37.3042 38.6725 37.4317 38.6219 37.5423 38.5293C37.6443 38.4366 37.6953 38.3102 37.6953 38.1586C37.6953 38.0069 37.6443 37.889 37.5423 37.7879C37.4402 37.6868 37.3042 37.6447 37.1512 37.6447C36.9982 37.6447 36.8706 37.6952 36.7601 37.7879C36.6581 37.889 36.6071 38.0069 36.6071 38.1586C36.6071 38.3102 36.6581 38.4282 36.7601 38.5293C36.8621 38.6303 36.9897 38.6725 37.1512 38.6725Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4974 34.6202C46.7153 34.6202 46.0607 34.8898 45.5336 35.4289C45.0065 35.9681 44.743 36.6253 44.743 37.4003C44.743 37.7795 44.8195 38.1586 44.9725 38.5208H43.9778H43.7823H42.7791V34.1231H41.0703C40.4412 34.1231 39.9397 34.2748 39.5741 34.5696C39.1235 34.9487 38.9025 35.4963 38.9025 36.204V39.7087H36.6666C36.1055 39.7087 35.5444 39.5655 34.9918 39.2791L34.6433 39.953C35.2979 40.2984 36.0545 40.4669 36.9132 40.4669H39.6676V36.0777C39.6676 35.6901 39.7951 35.3868 40.0587 35.1846C40.3222 34.9824 40.6623 34.8813 41.0788 34.8813H42.014V39.2791H43.7823H43.9778H45.4656C46.0012 39.8519 46.6643 40.13 47.4634 40.13C48.254 40.13 48.9256 39.8688 49.4612 39.3465C50.0053 38.8241 50.2774 38.1754 50.2774 37.3919C50.2774 36.6084 50.0053 35.9513 49.4782 35.4121C48.9342 34.8898 48.2795 34.6202 47.4974 34.6202ZM48.9172 38.8073C48.5261 39.1864 48.05 39.3717 47.4804 39.3717C46.9108 39.3717 46.4432 39.178 46.0692 38.7904C45.6951 38.4029 45.5081 37.9311 45.5081 37.3835C45.5081 36.8359 45.6951 36.3641 46.0692 35.9766C46.4432 35.589 46.9193 35.3953 47.4889 35.3953C48.067 35.3953 48.5431 35.589 48.9257 35.9681C49.3082 36.3472 49.5037 36.8275 49.5037 37.4003C49.5037 37.9564 49.3082 38.4366 48.9172 38.8073Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5249 32.6572H52.7598V38.0069H53.5249V32.6572Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3397 37.1644C67.3397 37.611 67.2207 37.9648 66.9742 38.2175C66.7276 38.4787 66.3791 38.6051 65.9285 38.6051C65.4779 38.6051 65.1038 38.4787 64.8233 38.226C64.5428 37.9732 64.3897 37.6531 64.3812 37.274V34.5865H63.6161V37.2318C63.6161 37.6699 63.4886 37.9901 63.242 38.2007C62.9955 38.4113 62.6894 38.5208 62.3154 38.5208H60.8276V34.5949H60.0625V38.5208H58.0477C57.5971 38.5208 57.24 38.4534 56.9765 38.3186C56.713 38.1838 56.5004 37.9732 56.3474 37.6952C56.4324 37.4256 56.4749 37.156 56.4749 36.8864V31.6294H57.1805V30.8712H55.7013V36.8864C55.7013 37.4425 55.5398 37.8553 55.1997 38.1249C54.8596 38.3945 54.4176 38.5208 53.8565 38.5208H51.2125L51.3061 39.2791H53.5674C54.8171 39.2791 55.6588 38.9421 56.0923 38.2597C56.2454 38.563 56.4664 38.8073 56.7555 38.9926C57.0105 39.1611 57.3761 39.2454 57.8436 39.2622V39.2706H62.3069C63.0465 39.2706 63.6076 38.9842 64.0072 38.3945C64.3982 39.0347 65.0358 39.3633 65.903 39.3633C67.3737 39.3633 68.1048 38.5882 68.1048 37.0381V33.5671H67.3397V37.1644Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5139 32.6572H70.7488V38.0069H71.5139V32.6572Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1792 40.6017C70.1792 41.3684 70.5363 41.7475 71.2589 41.7475H71.6499V41.3178H71.3269C70.9273 41.3178 70.7318 41.1409 70.7318 40.7871H71.956V40.2816H70.1792V40.6017Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6818 36.8864C73.6818 37.4425 73.5203 37.8553 73.1802 38.1249C72.8401 38.3945 72.3981 38.5208 71.837 38.5208H69.2015L69.2951 39.2791H71.5564C72.5341 39.2791 73.2652 39.0684 73.7413 38.6556C74.2174 38.2344 74.4554 37.6447 74.4554 36.8864V31.6294H75.161V30.8712H73.6818V36.8864Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8645 31.5704H77.0993V39.2791H77.8645V31.5704Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3776 35.707H85.9578V35.3279C85.9578 35.1509 86.0003 35.0161 86.0853 34.9319C86.1704 34.8392 86.3064 34.7971 86.5104 34.7971H87.0715V34.3674H86.4934C86.1279 34.3674 85.8558 34.4601 85.6773 34.6454C85.4987 34.8308 85.4052 35.1172 85.4052 35.5216V36.2124H87.3776V35.707Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2234 33.0616C92.3764 33.0616 92.5039 33.0111 92.6144 32.9184C92.7165 32.8257 92.7675 32.6993 92.7675 32.5477C92.7675 32.396 92.7165 32.2781 92.6144 32.177C92.5124 32.0759 92.3764 32.0254 92.2234 32.0254C92.0703 32.0254 91.9428 32.0759 91.8323 32.177C91.7303 32.2781 91.6793 32.396 91.6793 32.5477C91.6793 32.6993 91.7303 32.8173 91.8323 32.9184C91.9343 33.0111 92.0703 33.0616 92.2234 33.0616Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1649 40.2479C95.0118 40.2479 94.8843 40.2985 94.7738 40.3911C94.6718 40.4922 94.6123 40.6102 94.6123 40.7618C94.6123 40.9135 94.6633 41.0314 94.7653 41.1241C94.8673 41.2167 95.0033 41.2673 95.1564 41.2673C95.3094 41.2673 95.4369 41.2167 95.5474 41.1241C95.6494 41.0314 95.7004 40.905 95.7004 40.7618C95.7004 40.6186 95.6494 40.4922 95.5474 40.3995C95.4454 40.2985 95.3179 40.2479 95.1649 40.2479Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9958 38.5208H96.7461H96.5506H95.5474V34.1231H94.7823V38.5208H93.8471H93.6516H92.6485V34.1231H91.8833V38.5208H91.2627H90.7526H89.5709V31.5704H88.8058V38.5208H85.6858C85.0397 38.5208 84.5466 38.386 84.215 38.1249C83.8835 37.8553 83.7135 37.4256 83.7135 36.8275V35.0161H82.9483V36.937C82.9483 37.2487 83.0078 37.5604 83.1184 37.8806C83.2289 38.2007 83.4074 38.4703 83.654 38.6809C83.892 38.8915 84.181 39.0432 84.5126 39.1443C84.8441 39.2369 85.2777 39.2875 85.8218 39.2875H90.7611H91.2712H93.6601H93.8556H96.5591H96.7546H98.7695V31.5788H98.0043V38.5208H97.9958Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.728 31.5704H100.963V39.2791H101.728V31.5704Z",
    fill: "#173C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9378 12.2778C76.9378 12.6569 76.8103 12.9939 76.6063 13.2803L78.247 15.6645L82.0557 15.6898L82.8633 15.6982L83.1354 15.1169L84.4786 12.2441L82.0812 9.00056L77.839 8.82364L76.4192 11.0562C76.7338 11.3679 76.9378 11.7976 76.9378 12.2778Z",
    fill: "url(#paint0_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.212 10.5676C75.4246 10.5676 75.6201 10.6097 75.8071 10.6771L77.2014 8.49507L75.1355 6.14457L74.4809 6.19512L71.2504 6.43101L69.0315 9.2533L70.7913 12.0672L72.4321 11.9408L73.5457 11.8565C73.7413 11.1152 74.4044 10.5676 75.212 10.5676Z",
    fill: "url(#paint1_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5426 20.2392L75.3821 20.1549L75.5521 19.8432L77.6349 16.0436L76.0707 13.7605C75.8156 13.9038 75.5266 13.9964 75.212 13.9964C74.3619 13.9964 73.6563 13.3814 73.5202 12.5726L72.5001 12.6485L70.8168 12.7748L68.5469 16.5407L69.5841 18.3604C69.7796 18.3099 69.9837 18.2762 70.1962 18.2762C71.3694 18.2846 72.3471 19.1271 72.5426 20.2392Z",
    fill: "url(#paint2_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5681 20.9384C72.4236 22.1094 71.4204 23.0193 70.1962 23.0193C70.0347 23.0193 69.8816 23.0025 69.7286 22.9772L68.4959 25.4625H68.4874L70.6298 29.0009H75.8411L78.0855 25.1676L75.3991 20.8626L72.5681 20.9384Z",
    fill: "url(#paint3_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8803 16.4059L82.4297 16.3975L78.264 16.3722L76.0792 20.3655L76.0112 20.4835L78.4936 24.4684L83.1864 24.3336L85.1927 20.2223L84.0365 18.3099L82.8803 16.4059Z",
    fill: "url(#paint4_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6316 6.60793L83.943 6.47314L83.2204 7.72L82.6848 8.62987L85.0822 11.8734L86.8505 12.1261L88.7378 12.3873L89.4179 10.3232L89.5454 9.91885L87.1905 7.09657L84.6316 6.60793Z",
    fill: "url(#paint5_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5284 16.3722C89.5284 15.9173 89.758 15.5129 90.115 15.277L88.8143 13.1792L88.7718 13.1034L86.8675 12.8338L85.0907 12.5811L83.5944 15.774L83.4839 16.0184L84.6401 17.9308L85.7963 19.8432L89.5709 19.8516L89.69 19.5315L90.4211 17.6022C89.911 17.4337 89.5284 16.9451 89.5284 16.3722Z",
    fill: "url(#paint6_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1724 16.1784L93.048 16.2711L93.8131 16.3554L94.2552 13.9459L92.6994 11.3679L92.4189 10.9045L92.0959 10.8119L90.183 10.2811L90.0555 10.6771L89.3839 12.7327L89.4434 12.8254L90.8291 15.0579C90.8461 15.0579 90.8546 15.0579 90.8716 15.0579C91.5263 15.0495 92.0703 15.5382 92.1724 16.1784Z",
    fill: "url(#paint7_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8471 17.0715L93.048 16.9872L92.0873 16.8861C91.9258 17.2652 91.5858 17.5517 91.1777 17.6528L90.5401 19.3377L90.2085 20.2055L91.9003 23.7017L94.3317 23.4574L95.2159 20.3234L93.8471 17.0715Z",
    fill: "url(#paint8_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8928 14.3755L94.4677 16.7008L95.8365 19.9443L96.9332 19.9527L97.1457 17.5685L96.049 14.8726L95.4199 14.603L94.8928 14.3755Z",
    fill: "url(#paint9_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6728 16.9282L97.5112 16.0605L96.9757 14.3924L96.6271 13.3814L96.5676 13.3224L96.6696 14.5188L97.6728 16.9282Z",
    fill: "url(#paint10_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8938 18.1582L97.8598 18.1414L97.8173 18.1161L97.6218 20.2897L98.1573 22.7834L98.2339 22.7581L98.3869 20.5761L97.8938 18.1582Z",
    fill: "url(#paint11_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.879 20.652H95.862L94.9948 23.727L96.8481 26.6419L97.2817 25.8584L97.5197 23.2468L96.9672 20.6604L95.879 20.652Z",
    fill: "url(#paint12_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7941 6.70903L90.149 9.53974L92.3424 10.1463L92.5039 8.90788L91.1437 7.33246L90.4126 6.48156L88.2617 5.62224L87.7941 6.70903Z",
    fill: "url(#paint13_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1075 8.52877L93.9151 9.00898L93.8811 8.87419L91.5177 6.30464L90.9907 5.95923L90.9821 6.06033L91.7643 6.96177L93.1075 8.52877Z",
    fill: "url(#paint14_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1755 9.39652L93.0565 10.5928L94.8673 13.6005L95.3434 13.8027L95.913 14.047L95.794 12.6822L95.7855 12.5726L94.9013 11.1404L94.2212 10.0199L93.6431 9.67454L93.1755 9.39652Z",
    fill: "url(#paint15_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3894 4.05524L77.5499 3.83619H77.5159L75.7646 5.79073L77.8135 8.12438L82.0642 8.3013L82.5998 7.39143L83.3139 6.16142L82.1492 5.08306L81.6816 4.65339C81.5711 4.69552 81.4606 4.72079 81.333 4.72079C80.891 4.70394 80.5254 4.43435 80.3894 4.05524Z",
    fill: "url(#paint16_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2087 4.17318L82.7868 4.70394L83.9345 5.75704L87.1735 6.37204L87.6496 5.2684L85.5242 3.45708L82.6168 2.7831L82.5913 2.8168L82.2002 3.25489C82.2767 3.39811 82.3277 3.54975 82.3277 3.72667C82.3192 3.87832 82.2767 4.02996 82.2087 4.17318Z",
    fill: "url(#paint17_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.285 5.66436V5.47059L88.3892 3.90359L86.4934 2.79995L86.2044 3.10324L88.2532 4.85559L90.285 5.66436Z",
    fill: "url(#paint18_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0398 1.30035L75.9602 1.9996L77.4904 3.12852L80.3979 3.35599C80.5424 2.99372 80.8995 2.73256 81.3246 2.73256C81.4436 2.73256 81.5541 2.75783 81.6561 2.79153L81.8686 2.56406L81.9452 2.47981L80.3384 1.49412L77.0908 1.30035H77.0398Z",
    fill: "url(#paint19_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1249 0.592672L80.0748 0.735893L79.7263 0.676919L76.8273 0.5L77.0568 0.592672H77.1249Z",
    fill: "url(#paint20_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2375 2.34502L71.871 2.69043L70.0262 4.32483L70.3152 4.67024L71.2249 5.72333L74.4384 5.48744L75.1185 5.43689L76.8358 3.51605L76.7508 3.44866L75.2375 2.34502Z",
    fill: "url(#paint21_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7945 1.99118L75.212 1.63734L75.5606 1.40987L76.1812 1.00548L75.6201 0.778017L72.3641 1.08131L71.2759 1.70474L71.735 1.95748L71.7945 1.99118Z",
    fill: "url(#paint22_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6338 2.05858L85.5753 2.74098L85.7708 2.53036L85.8558 2.44611L85.5072 2.25234L81.4861 0.988634L81.163 1.16555L81.3586 1.2835L82.6338 2.05858Z",
    fill: "url(#paint23_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4407 8.52877L64.9253 9.67453L67.5097 9.11008L68.3939 8.91631L70.6128 6.09402L69.6011 4.91456L69.4226 4.70394L66.2515 5.46217L64.5428 7.39143C64.6193 7.54308 64.6703 7.70315 64.6703 7.88849C64.6618 8.12438 64.5768 8.35185 64.4407 8.52877Z",
    fill: "url(#paint24_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5991 6.82698C63.7436 6.82698 63.8711 6.85225 63.9987 6.9028L65.6139 5.09991L65.3419 4.65339L65.2994 4.586L63.3611 5.47059L61.6948 7.17239L61.2527 7.64418L61.3802 8.38555L62.5279 7.89692C62.5279 7.29876 63.004 6.82698 63.5991 6.82698Z",
    fill: "url(#paint25_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2484 3.83619L65.3164 3.78565L65.4779 3.65928L64.8488 4.02154L64.8913 3.99626L65.2484 3.83619Z",
    fill: "url(#paint26_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3291 3.93729L71.1059 2.41242L71.0633 2.39557L70.5108 2.08385L67.7223 2.80838L66.4471 3.8025L65.903 4.22373L66.2175 4.73764L69.3291 3.93729Z",
    fill: "url(#paint27_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9338 10.3991L64.0412 11.806L62.851 13.7016L64.1517 16.6502L67.7733 16.229L67.9178 16.2121L70.1452 12.4378L68.4194 9.63241L67.6203 9.80933L64.9338 10.3991Z",
    fill: "url(#paint28_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4281 13.8195L61.6013 13.5246L62.2134 13.373L63.4631 11.3932L64.3047 10.0621L63.8286 8.92473C63.7521 8.94158 63.6756 8.95001 63.5906 8.95001C63.2675 8.95001 62.9785 8.80679 62.783 8.57932L61.2782 9.2533L59.85 11.4522L59.4504 12.0587L59.748 13.432C60.0115 13.4909 60.2495 13.6342 60.4281 13.8195Z",
    fill: "url(#paint29_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7215 17.9813L57.7331 17.737L58.6003 15.7656C58.2942 15.5213 58.0987 15.1506 58.0987 14.7378C58.0987 14.1481 58.4897 13.651 59.0253 13.4741L58.8213 12.5305L57.8266 13.0697L57.6651 13.154L56.4239 16.0184L56.5769 18.0234L56.7215 17.9813Z",
    fill: "url(#paint30_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7256 8.80679L60.6151 8.13281L59.9435 8.60459L59.5439 8.88261L57.8521 11.3763L57.7841 12.2778L58.8213 11.7217L60.7256 8.80679Z",
    fill: "url(#paint31_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4504 16.0689C59.3824 16.0689 59.3229 16.0605 59.2549 16.0521L58.3707 18.0571L59.2464 20.9553L61.8053 20.6857L62.9105 18.352L63.5396 17.0209L63.3186 16.5238L62.2474 14.0975L61.5928 14.266L60.7766 14.4766C60.7936 14.5609 60.8021 14.6536 60.8021 14.7462C60.8021 15.4708 60.1985 16.0689 59.4504 16.0689Z",
    fill: "url(#paint32_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8073 20.652C67.8073 19.8095 68.2579 19.0681 68.9295 18.6469L67.9433 16.9198L67.6118 16.9619L64.1687 17.3663L63.5396 18.6974L62.4429 21.0227L64.2282 24.7548H68.0623L69.0655 22.7413C68.3089 22.3285 67.8073 21.5534 67.8073 20.652Z",
    fill: "url(#paint33_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3229 21.6629L58.3707 24.8306L59.7905 28.0152L62.3579 28.3353L63.6076 25.1171L61.8308 21.4607L59.3229 21.6629Z",
    fill: "url(#paint34_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7608 16.7092L55.2592 17.1726C55.0807 18.0234 54.7491 19.8348 54.7916 21.6292L55.1232 21.6208L55.8968 18.4363L55.7608 16.7092Z",
    fill: "url(#paint35_linear_277_552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7416 18.4615L56.934 18.6553L56.5514 18.748L55.8458 21.6545L56.5259 24.3504L57.7246 24.4768L58.6173 21.3344L57.7416 18.4615Z",
    fill: "url(#paint36_linear_277_552)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_277_552",
    x1: 66.6299,
    y1: 12.2599,
    x2: 88.69,
    y2: 12.2599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_277_552",
    x1: 66.6299,
    y1: 9.10839,
    x2: 88.69,
    y2: 9.10839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_277_552",
    x1: 66.6299,
    y1: 16.402,
    x2: 88.69,
    y2: 16.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_277_552",
    x1: 66.6299,
    y1: 24.9279,
    x2: 88.69,
    y2: 24.9279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_277_552",
    x1: 66.6299,
    y1: 20.4211,
    x2: 88.69,
    y2: 20.4211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_277_552",
    x1: 66.6299,
    y1: 9.43278,
    x2: 88.69,
    y2: 9.43278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_277_552",
    x1: 66.6299,
    y1: 16.2257,
    x2: 88.69,
    y2: 16.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_277_552",
    x1: 66.6299,
    y1: 13.3156,
    x2: 88.69,
    y2: 13.3156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_277_552",
    x1: 66.6299,
    y1: 20.2879,
    x2: 88.69,
    y2: 20.2879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_277_552",
    x1: 66.6299,
    y1: 17.1656,
    x2: 88.69,
    y2: 17.1656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_277_552",
    x1: 66.6301,
    y1: 15.129,
    x2: 88.69,
    y2: 15.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_277_552",
    x1: 66.6301,
    y1: 20.4489,
    x2: 88.6901,
    y2: 20.4489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_277_552",
    x1: 66.6299,
    y1: 23.6494,
    x2: 88.69,
    y2: 23.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_277_552",
    x1: 66.6299,
    y1: 7.88508,
    x2: 88.69,
    y2: 7.88508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_277_552",
    x1: 66.6299,
    y1: 7.48461,
    x2: 88.69,
    y2: 7.48461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_277_552",
    x1: 66.6299,
    y1: 11.7193,
    x2: 88.69,
    y2: 11.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_277_552",
    x1: 66.6299,
    y1: 6.0612,
    x2: 88.69,
    y2: 6.0612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_277_552",
    x1: 66.6299,
    y1: 4.57593,
    x2: 88.69,
    y2: 4.57593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_277_552",
    x1: 66.6299,
    y1: 4.23311,
    x2: 88.69,
    y2: 4.23311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_277_552",
    x1: 66.6299,
    y1: 2.32229,
    x2: 88.69,
    y2: 2.32229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_277_552",
    x1: 66.6299,
    y1: 0.618013,
    x2: 88.69,
    y2: 0.618013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_277_552",
    x1: 66.6299,
    y1: 4.03114,
    x2: 88.69,
    y2: 4.03114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_277_552",
    x1: 66.6299,
    y1: 1.38358,
    x2: 88.69,
    y2: 1.38358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_277_552",
    x1: 66.6299,
    y1: 1.86463,
    x2: 88.69,
    y2: 1.86463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_277_552",
    x1: 66.6299,
    y1: 7.18943,
    x2: 88.69,
    y2: 7.18943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_277_552",
    x1: 66.6299,
    y1: 6.48638,
    x2: 88.69,
    y2: 6.48638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_277_552",
    x1: 66.6299,
    y1: 3.8391,
    x2: 88.6903,
    y2: 3.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_277_552",
    x1: 66.6299,
    y1: 3.41055,
    x2: 88.69,
    y2: 3.41055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_277_552",
    x1: 66.6299,
    y1: 13.1405,
    x2: 88.69,
    y2: 13.1405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_277_552",
    x1: 66.6299,
    y1: 11.1971,
    x2: 88.69,
    y2: 11.1971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_277_552",
    x1: 66.6299,
    y1: 15.2715,
    x2: 88.6899,
    y2: 15.2715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_277_552",
    x1: 66.6299,
    y1: 10.2085,
    x2: 88.6899,
    y2: 10.2085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_277_552",
    x1: 66.6299,
    y1: 17.5223,
    x2: 88.69,
    y2: 17.5223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_277_552",
    x1: 66.6299,
    y1: 20.8348,
    x2: 88.69,
    y2: 20.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_277_552",
    x1: 66.6299,
    y1: 24.8978,
    x2: 88.69,
    y2: 24.8978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_277_552",
    x1: 66.6299,
    y1: 19.1661,
    x2: 88.69,
    y2: 19.1661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_277_552",
    x1: 66.6299,
    y1: 21.4666,
    x2: 88.69,
    y2: 21.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#23706B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8389,
    stopColor: "#234772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243772"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 53,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsdbLogo);
export default __webpack_public_path__ + "static/media/ISDBLogo.bc8e82a61187b526a80666523b87c5f3.svg";
export { ForwardRef as ReactComponent };